import { Provider, Type } from '@angular/core';
import { RouteTitlesProviderService } from '../providers/route-titles-provider.service';

export const provideTitles = (
  provider: Type<RouteTitlesProviderService>,
): Provider => ({
  provide: RouteTitlesProviderService,
  useClass: provider,
});
